const UserRoles = {
  SuperAdmin: "1001",
  PricingAdmin: "1002",
  PricingApprover: "1003",
  Viewer: "1004",
  ContractAuthorityManager: "1005",
};

const countryLocaleMapping = {
  "D-PT": [
    { key: "pt_PT", value: "Portuguese" }
  ],
  "D-NL": [
    { key: "nl_NL", value: "Dutch" }
  ],
  "D-FR": [
    { key: "fr_FR", value: "French" }
  ],
  "D-IT": [
    { key: "it_IT", value: "Italian" }
  ],
  "D-DK": [
    { key: "da_DK", value: "Danish" }
  ],
  "D-CH": [
    { key: "de_CH", value: "German" }
  ],
  "D-AT": [
    { key: "de_CH", value: "German" }
  ],
  "D-DE": [
    { key: "de_CH", value: "German" }
  ],
  "D-NO": [
    { key: "nb_NO", value: "Norwegian " }
  ]
};

const CurrencyConfig = [
  { locale: "pt_PT", option: { style: "currency", currency: "EUR", currencyDisplay: "symbol" } },
  { locale: "en_GB", option: { style: "currency", currency: "GBP", currencyDisplay: "symbol" } },
  { locale: "fr_FR", option: { style: "currency", currency: "EUR", currencyDisplay: "symbol" } },
  { locale: "de_CH", option: { style: "currency", currency: "CHF", currencyDisplay: "symbol" } },
  { locale: "fr_CH", option: { style: "currency", currency: "CHF", currencyDisplay: "symbol" } },
  { locale: "it_CH", option: { style: "currency", currency: "CHF", currencyDisplay: "symbol" } },
  { locale: "de_AT", option: { style: "currency", currency: "EUR", currencyDisplay: "symbol" } },
  { locale: "de_DE", option: { style: "currency", currency: "EUR", currencyDisplay: "symbol" } },
  { locale: "nb_NO", option: { style: "currency", currency: "NOK", currencyDisplay: "symbol" } }
];


const UIElementType = Object.freeze({
  TEXTFIELD: "TextField",
  DROPDOWN: "DropDown",
  RADIOBUTTON: "RadioButton",
  CHECKBOX: "Checkbox"
});

export { UserRoles, UIElementType, countryLocaleMapping, CurrencyConfig };
